import { socket } from "./socket";

export const joinRoomInbox = (emetteur, destinataire, workspaceId) => {
  const userInitiator = { userId: emetteur.userId };
  socket.emit("joinRoomInbox", {
    userInitiator,
    destinataire: { userId: destinataire.userId },
    workspaceId,
  });
};

export const addOrRemoveToFavorite = (userId, roomId, workspaceId) => {
  socket.emit("ajouter_ou_retirer_le_canal_aux_favoris", { userId, roomId, workspaceId });
};
